import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CombiDealModal, DismissedCombiDealModal } from "./types";
import { newCustomerCleanup } from "../actions";
import { calculateCart } from "../cart/async-thunk";
import { Product } from "@/types/product";

interface UiState {
  initialEan: string | undefined;
  combiDealModals: CombiDealModal[];
  dismissedCombiDealModals: DismissedCombiDealModal[];
}

const getInitialState = (): UiState => ({
  initialEan: undefined,
  combiDealModals: [],
  dismissedCombiDealModals: [],
});

const uiSlice = createSlice({
  name: "ui",
  initialState: getInitialState(),
  reducers: {
    setInitialEan: (state, { payload }: PayloadAction<string>) => {
      state.initialEan = payload;
    },
    resetInitialEan: (state) => {
      state.initialEan = undefined;
    },
    dismissCombiDealModal: (state, { payload }: PayloadAction<CombiDealModal>) => {
      state.dismissedCombiDealModals.push({ productId: payload.productId });
    },
    reshowCombiDealModal: (state, { payload }: PayloadAction<Product["id"]>) => {
      state.dismissedCombiDealModals = state.dismissedCombiDealModals.filter(
        (modal) => modal.productId !== payload
      );
    },
  },
  extraReducers: (builder) => {
    builder.addCase(newCustomerCleanup, () => getInitialState());

    builder.addCase(calculateCart.fulfilled, (state, { payload }) => {
      state.combiDealModals = payload.lineItems.products
        .filter((product) => product.combiDeals.length && !product.combiDealApplied)
        .map((product) => ({
          productId: product.productId,
          combinableProductIds: [
            ...new Set(product.combiDeals.flatMap((combiDeal) => combiDeal.combinableProductIds)),
          ],
          priceCents:
            product.combiDeals.length === 1 ? product.combiDeals[0].priceCents : undefined,
        }));
    });
  },
});

export const {
  setInitialEan,
  resetInitialEan,
  dismissCombiDealModal,
  reshowCombiDealModal,
} = uiSlice.actions;
export default uiSlice.reducer;
